import classificationModule from "./classificationModule"
import classificationView from "./classificationView.html"

classificationModule.config(["editionServiceProvider", (editionServiceProvider) =>{
    editionServiceProvider.registerEdition("classification", classificationView, "classificationController")
}])